/**
 * Identidade visual do avatar: iniciais e gradiente estáveis por nome.
 *
 * Vive fora do componente porque um arquivo que exporta componente e função ao
 * mesmo tempo quebra o recarregamento rápido do Vite. O gradiente é derivado do
 * próprio nome, então o mesmo lead tem sempre a mesma cor em qualquer
 * superfície — é sinal de reconhecimento, nunca de estado ou categoria, que
 * dependem de texto e forma (AGENTS §11).
 */

const GRADIENTS: ReadonlyArray<readonly [string, string]> = [
  ["#2e63ff", "#8e85ff"],
  ["#8e85ff", "#e0578a"],
  ["#1faf63", "#2e63ff"],
  ["#ff8a5c", "#e0578a"],
  ["#3e9bff", "#4adec9"],
  ["#8e85ff", "#f272a8"],
];

/** Primeira letra do primeiro e do segundo nome, em caixa alta. */
export function avatarInitials(name: string): string {
  const words = name.trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return "?";
  return words
    .slice(0, 2)
    .map((word) => word.charAt(0))
    .join("")
    .toUpperCase();
}

export function avatarGradient(name: string): string {
  let hash = 0;
  for (const char of name) hash = (hash * 31 + char.charCodeAt(0)) % GRADIENTS.length;
  const [from, to] = GRADIENTS[hash];
  return `linear-gradient(135deg, ${from}, ${to})`;
}
